import { memo } from 'react';
import { UserAddTemplate } from 'components/templates/UserAddTemplate';

type Props = {};

export const UserAdd = memo((_props: Props) => {
	return <UserAddTemplate />;
});
